import React, { useState } from 'react';
import Input from './Input';

interface LabeledInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  className?: string;
  disabled?: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  inputRef?: React.Ref<HTMLInputElement>;
  icon?: React.ReactNode;
  errorText?: string;
  onValidate?: (value: string) => boolean;
}

const LabeledInput: React.FC<LabeledInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  className,
  disabled,
  onFocus,
  onBlur,
  inputRef,
  icon,
  errorText,
  onValidate,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isLocalError, setisLocalError] = useState(false);

  const hasValue = value.trim() !== '';
  const isActive = isFocused || hasValue;
  const textColor = isActive ? 'text-white' : 'text-text_sub';
  const borderColor = isLocalError ? 'border-b-text_error' : isActive ? 'border-b-white' : 'border-b-text_sub';

  return (
    <div className="mb-[16px] mt-2">
      <div className="h-[76px]">
        <div className="mb-[10px] text-sm font-medium leading-4 text-contentText">{label}</div>
        <Input
          ref={inputRef}
          value={value}
          className={`rounded-none border-0 border-b bg-transparent px-0 pb-[13px] text-lg font-normal focus:outline-none ${textColor} ${borderColor} ${className || ''}`}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          icon={icon}
          onFocus={(e) => {
            setIsFocused(true);
            onFocus?.(e);
          }}
          onBlur={(e) => {
            setIsFocused(false);

            if (onValidate) {
              setisLocalError(!onValidate(value));
            }

            onBlur?.(e);
          }}
        />
        {isLocalError && <div className="text-text_error mt-1 text-xs leading-4">{errorText}</div>}
      </div>
    </div>
  );
};

export default LabeledInput;
